define('common/ckeditor/config_amp',['require','exports','module','fontmanager'],function (require, exports, module) {
  "use strict";

  var fontManager = require("fontmanager");

  var config = {
    extraPlugins: "find,selectall,div,showblocks,justify,colorbutton,font",
    fullPage: false,
    resize_enabled: true,
    allowedContent: true,
    autoParagraph: false,
    editorPlatform: 'amp',
    toolbar: [
      ["Source"], {
        name: "clipboard",
        groups: ["clipboard", "undo"],
        items: ["Cut", "Copy", "Paste", "PasteText", "-", "Undo", "Redo"]
      }, {
        name: "find",
        groups: ["find"],
        items: ["Find", "Replace", "-", "SelectAll"]
      }, {
        name: "basicstyles",
        groups: ["style"],
        items: ["Bold", "Italic", "Underline", "Strike", "-", "RemoveFormat"]
      }, {
        items: ["Link", "Unlink", "Table", "HorizontalRule", "SpecialChar"]
      }, {
        items: ["NumberedList", "BulletedList",
          "-", "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"
        ]
      }, {
        name: "styles",
        items: ["Styles", "Format", "Font", "FontSize"]
      }, {
        name: "colors",
        items: ["TextColor", "BGColor"]
      }
    ],
    contentsCss: [fontManager.getCustomFontsLink(), '/app/styles/ckeditor-overrides.css'],
    font_names: fontManager.getNames().join(";")
  };

  module.exports = config;
});

